import { BaseCommand, createTable } from "@crunchdao/shared-cli";
import chalk from "chalk";

export class ListAccountsCommand extends BaseCommand {
  async execute(): Promise<void> {
    try {
      // Get all account infos first without decoding
      const programId = this.stakingProgram.programId;
      const allAccounts = await this.provider.connection.getProgramAccounts(programId);

      const stakingAccounts = [];
      const failedAccounts = [];

      // Try to decode each account individually
      for (const accountInfo of allAccounts) {
        try {
          const decoded = this.stakingProgram.coder.accounts.decode(
            "stakingAccount",
            accountInfo.account.data
          );
          stakingAccounts.push({
            publicKey: accountInfo.pubkey,
            account: decoded,
          });
        } catch {
          // Skip accounts that fail to decode (likely old structure or different account type)
          failedAccounts.push(accountInfo.pubkey.toBase58());
        }
      }

      if (this.resolvedOptions.output === "json") {
        this.output({
          accounts: stakingAccounts.map((acc) => ({
            publicKey: acc.publicKey.toBase58(),
            userKey: acc.account.userKey.toBase58(),
            coordinatorKey: acc.account.coordinatorKey.toBase58(),
            nextIndex: acc.account.nextIndex,
          })),
          total: stakingAccounts.length,
          failed: failedAccounts.length,
        });
      } else {
        console.log(chalk.cyan.bold("\n📋 All Staking Accounts"));
        console.log(chalk.gray("═".repeat(120)));
        console.log(`Total accounts: ${stakingAccounts.length}`);
        if (failedAccounts.length > 0) {
          console.log(
            chalk.yellow(`⚠️  Skipped ${failedAccounts.length} accounts (decode failed)`)
          );
        }
        console.log();

        if (stakingAccounts.length === 0) {
          console.log(chalk.gray("No staking accounts found.\n"));
          return;
        }

        const table = createTable({
          colWidths: [50, 50, 15],
        });

        table.push([chalk.yellow("User"), chalk.yellow("Coordinator"), chalk.yellow("Next Index")]);

        stakingAccounts.forEach((account) => {
          table.push([
            chalk.white(account.account.userKey.toBase58()),
            chalk.cyan(account.account.coordinatorKey.toBase58()),
            chalk.gray(account.account.nextIndex.toString()),
          ]);
        });

        console.log(table.toString());
        console.log();
      }
    } catch (error) {
      console.error("❌ Error listing staking accounts:", error);
      throw error;
    }
  }
}
